import React from 'react';

const Issu = ({ src, numero }) => {
  if (!src) return null;
  return (
    <div style={{ position: 'relative', paddingTop: 'max(60%, 326px)', height: 0, width: '100%' }}>
      <iframe
        loading="lazy"
        allow="clipboard-write"
        sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
        allowFullScreen={true}
        style={{ position: 'absolute', border: 'none', width: '100%', height: '100%', left: 0, right: 0, top: 0, bottom: 0 }}
        src={src}
        title={`Boca de Sapo: revista número ${numero}`}
      />
    </div>
  );
};

export default Issu;
